export default __webpack_public_path__ + "static/media/13.29e57d34.png";